import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, ArrowRight, Star } from 'lucide-react';
import { useMetaPixel } from '../hooks/useMetaPixel';
export function PricingCTA() {
  const {
    trackAddToCart
  } = useMetaPixel();
  const handlePurchase = () => {
    trackAddToCart();
    window.location.href = 'https://pay.hotmart.com/X104481921V';
  };
  return <section id="pricing" className="py-20 px-4 bg-[#FDFBF7]" data-id="element-144">
      <div className="max-w-4xl mx-auto" data-id="element-145">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-100 relative" data-id="element-146">
          {/* Top Banner */}
          <div className="bg-[#2F855A] text-white text-center py-3 font-bold tracking-wide uppercase text-sm" data-id="element-147">
            Oferta Especial Limitada
          </div>

          <div className="p-8 md:p-12 text-center" data-id="element-148">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-149">
              Elige el control.
            </h2>
            <p className="text-xl text-gray-600 mb-8" data-id="element-150">
              Con tacos. Con guisos. Con vida real. Pero con palancas.
            </p>

            {/* Price Display */}
            <div className="flex flex-col items-center justify-center mb-10" data-id="element-151">
              <div className="flex items-center gap-4 mb-2" data-id="element-152">
                <span className="text-gray-400 text-2xl line-through font-medium" data-id="element-153">
                  $49.99
                </span>
                <span className="bg-orange-100 text-[#C05621] px-3 py-1 rounded-full text-sm font-bold" data-id="element-154">
                  Ahorras $40
                </span>
              </div>
              <div className="text-6xl font-extrabold text-gray-900 tracking-tight" data-id="element-155">
                $9.99{' '}
                <span className="text-2xl text-gray-500 font-normal" data-id="element-156">USD</span>
              </div>
            </div>

            {/* Main CTA */}
            <button onClick={handlePurchase} className="w-full md:w-auto px-8 py-5 bg-[#2F855A] hover:bg-[#276749] text-white text-xl font-bold rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all flex items-center justify-center mx-auto gap-3 group" data-id="element-157">
              Quiero Mi Plan Antipicos — $9.99
              <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-158" />
            </button>

            {/* Guarantee */}
            <div className="mt-8 flex items-center justify-center gap-2 text-gray-600 bg-gray-50 py-3 px-6 rounded-lg inline-flex" data-id="element-159">
              <ShieldCheck className="w-5 h-5 text-[#2F855A]" data-id="element-160" />
              <span className="font-medium text-sm" data-id="element-161">
                7 días de garantía de devolución
              </span>
            </div>

            <p className="mt-6 text-sm text-gray-500 max-w-md mx-auto" data-id="element-162">
              Acceso inmediato al PDF digital. Pago seguro. No es un "reto" de
              moda. Es una estructura para tu vida real.
            </p>
          </div>

          {/* Decorative bottom strip */}
          <div className="h-2 bg-gradient-to-r from-[#C05621] via-[#F6E05E] to-[#2F855A]" data-id="element-163"></div>
        </motion.div>
      </div>
    </section>;
}